<template>
  <b-card
    no-header
    no-body>
    <div
      :ref="divRef"
      :class="`${divClass} overflow-auto`" />
  </b-card>
</template>

<script>
  import jsonDiff from "json-diff"
  import {create as jsonDiffPatchCreate, formatters as jsonDiffPatchFormatters} from 'jsondiffpatch'

  export default {
    name: "JsonDiffViewer",
    props: {
      divRef: {
        type: String,
        required: false,
        default: 'jsonVisual',
      },
      divClass: {
        type: String,
        required: false,
        default: 'json-diff-viewer',
      },
      emitOnChange: {
        type: String,
        required: false,
        default: 'json-diff-change',
      },
      originalJson: {
        type: Object,
        required: false,
        default: null,
      },
      changedJson: {
        type: Object,
        required: false,
        default: null,
      },
      showUnchanged: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        jsonDiffPatch: null,
        delta: null,
        jsonDiffToSave: null,
      }
    },
    watch: {
      changedJson(newVal) {
        this.renderJson(newVal)
      },
      originalJson() {
        this.renderJson(this.changedJson)
      },
      showUnchanged(newVal) {
        jsonDiffPatchFormatters.html.showUnchanged(newVal, this.$refs[this.divRef])
      },
    },
    async created() {
      const options = {arrays: {detectMove: true, includeValueOnMove: true}}
      this.jsonDiffPatch = jsonDiffPatchCreate(options)
    },
    async mounted() {
      this.renderJson(this.changedJson)
    },
    methods: {
      renderJson(newVal) {
        this.delta = jsonDiff.diff(this.originalJson, newVal)
        this.jsonDiffToSave = this.jsonDiffPatch.diff(this.originalJson, newVal)
        this.$refs[this.divRef].innerHTML = jsonDiffPatchFormatters.html.format(this.jsonDiffToSave, newVal)
        jsonDiffPatchFormatters.html.showUnchanged(this.showUnchanged, this.$refs[this.divRef])
        this.$emit(this.emitOnChange, this.jsonDiffToSave)
      },
    },
  }
</script>

<style scoped>
  @import "~jsondiffpatch/dist/formatters-styles/html.css";

  div >>> .json-diff-viewer {
    width: auto;
    height: 500px;
  }
</style>
